var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"avatar",class:_vm.type,attrs:{"to":"/account/profile","title":"Update profile"}},[_c('strong',[_vm._v(_vm._s(_vm.formatNameForIcon(_vm.person)))])])}
var staticRenderFns = []

export { render, staticRenderFns }